
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/migration/usage-with-material-ui-v5-v6",
      function () {
        return require("private-next-pages/x/migration/usage-with-material-ui-v5-v6.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/migration/usage-with-material-ui-v5-v6"])
      });
    }
  